import { clearEstimate } from '../State/estimate';
import { setSelectedRowKeys } from '../State/selectedRowKeys';

export default () => (dispatch) => {

  dispatch(clearEstimate());
  dispatch(setSelectedRowKeys([]));
  
}